module.exports = __webpack_public_path__ + "img/solution-network-components.93b7aa79.png";